import { Evaluation } from '@/models/evaluations';

export const platformsEmpty = (
  platforms: Evaluation.Form['platforms']
): boolean =>
  !Object.values(platforms).some((platform) =>
    Object.values(platform).some(Boolean)
  );

export const hasEmptyLogicalLevel = (
  query: Evaluation.Form['keywordQuery']
): boolean => {
  if (!query) return false;

  return query.elements.some((element) => {
    if (element.type !== 'logicalGroup') return false;
    if (element.elements.length === 0) return true;
    return hasEmptyLogicalLevel(element);
  });
};
